import React from "react";
import { Box, Divider, Paper, Typography } from "@mui/material";

interface EmissionChartPanelProps {
  children: React.ReactNode;
  headerAction?: React.ReactNode;
  title?: string;
}

const EmissionChartPanel: React.FC<EmissionChartPanelProps> = ({
  children,
  headerAction,
  title = "Baseline Emissions (BAU) Chart",
}) => {
  return (
    <>
      <Divider sx={{ my: 2 }} />

      <Paper
        variant="outlined"
        sx={{
          width: "100%",
          borderColor: "#d9e1e8",
          borderRadius: "12px",
          overflow: "hidden",
          backgroundColor: "#fff",
        }}
      >
        <Box
          sx={{
            px: { xs: 1.25, md: 2 },
            py: 0.9,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 0.75,
            flexWrap: "nowrap",
            borderBottom: "1px solid #e4eaf0",
            overflowX: "auto",
          }}
        >
          <Typography
            sx={{
              color: "#10284d",
              fontSize: "0.80rem",
              fontWeight: 680,
              whiteSpace: "nowrap",
              flexShrink: 0,
            }}
          >
            {title}
          </Typography>

          {headerAction}
        </Box>

        {children}
      </Paper>
    </>
  );
};

export default EmissionChartPanel;